import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';
import { SsrsConfigModel } from '../models/SsrsConfigModel';
import { ReportCategoryModel } from '../models/ReportCategoryModel';
import { ExtractMetadataModel } from '../models/ExtractMetadataModel';
import { BaseAddressInterceptor } from '../../core/interceptors/BaseAddressInterceptor';

@Injectable()
export class ExtractReportServiceFactory {
  constructor(private httpClient: HttpClient,
    private baseAddressInterceptor: BaseAddressInterceptor) { }

  getService(baseUrl: string): ExtractReportService {
    return new ExtractReportService(this.httpClient, this.baseAddressInterceptor, baseUrl);
  }
}

export class ExtractReportService {
  constructor(private httpClient: HttpClient,
    private baseAddressInterceptor: BaseAddressInterceptor,
    private baseUrl: string) { }

  listQuery(parameters: any, page: number, pageSize: number, sort: string, sortDirection: string): Observable<QueryResponse<any>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    return this.httpClient.post<QueryResponse<any>>(`${this.baseUrl}/ListQuery`, parameters, { params: params });
  }

  totalCount(parameters: any): Observable<ModelResponse<number>> {
    return this.httpClient.post<ModelResponse<number>>(`${this.baseUrl}/TotalCount`, parameters);
  }

  getExportUrl(parameters: any, page: number, pageSize: number, sort: string, sortDirection: string): Observable<ModelResponse<string>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    return this.httpClient.post<ModelResponse<string>>(`${this.baseUrl}/ExportUrl`, parameters, { params: params })
      .map(r => {
        r.model = this.baseAddressInterceptor.getApiUrl(r.model)
        return r;
      });
  }

  openExtract(url: string, parameters: any): void {
    var mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST"; // or "post" if appropriate
    mapForm.action = url;
    Object.keys(parameters).forEach((param) => {
      var value = parameters[param];
      if (Array.isArray(value)) {
        var select = document.createElement("select");
        select.multiple = true;
        select.name = param;
        value.forEach( (v) => {
          var option = document.createElement("option");
          select.add(option);
          option.setAttribute("value",v);
          option.selected = true;
        });
        mapForm.appendChild(select);
      } else {
        var mapInput = document.createElement("input");
        mapInput.type = "hidden";
        mapInput.name = param;
        mapInput.setAttribute("value", value);
        mapForm.appendChild(mapInput);
      }
    });
    document.body.appendChild(mapForm);
    mapForm.submit();
    setTimeout(() => document.body.removeChild(mapForm), 100);
  }

  getExtractMetadata(): Observable<ModelResponse<ExtractMetadataModel>> {
    return this.httpClient.get<ModelResponse<ExtractMetadataModel>>(`${this.baseUrl}/ExtractMetadata`);
  }
}



// WEBPACK FOOTER //
// ./src/app/report/services/ExtractReportService.ts